export default __webpack_public_path__ + "static/media/forest.12ae5a70.svg";